export const MenuKeys = {
  InternshipOffers: 'InternshipOffers',
  InternshipProcesses: 'InternshipProcesses',
  RegisterOrganization: 'RegisterOrganization',
  WorkReport: 'WorkReport',
  Students: 'Students',
  ResearchAgrements: 'ResearchAgrements',
  ResearchAgrementsForUniversityCoordonator:
    'ResearchAgrementsForUniversityCoordonator',
  StudentEvaluationSupervisor: 'StudentEvaluationSupervisor',
  Docs: 'Docs',
  SummaryTable: 'SummaryTable',
  StudentAssign: 'StudentAssign',
  RegisteredOrganizations: 'RegisteredOrganizations',
  ReprezentativeOrganization: 'ReprezentativeOrganization',
  ManageInternshipsOrganizationRepresentative:
    'ManageInternshipsOrganizationRepresentative',
  ManageSupervisors: 'ManageSupervisors',
  SupervisorAssign: 'SupervisorAssign',
  OrganizationsLegalDepartment: 'OrganizationsLegalDepartment',
  Conventions: 'Conventions',
  OrganizationsRector: 'OrganizationsRector',
  ManageInternshipsRector: 'ManageInternshipsRector',
  CreateUniversity: 'CreateUniversity',
  ManageUnuversityMembers: 'ManageUniversityMembers',
  UniversityOrganizationRegistration: 'UniversityOrganizationRegistration',
  CompetencyTable: 'CompetencyTable',
  ResearchAgreement: 'ResearchAgreement',
  StudyYears: 'StudyYears',
  StudyYearSetup: 'StudyYearSetup',
  ProcessStartSettings: 'ProcessStartSettings',
  ProcessRollback: 'ProcessRollback',
  RepresentativeDocs: 'RepresentativeDocs',
  PendingProcesses: 'PendingProcesses',
  SafetyDocuments: 'SafetyDocuments',
  UniversityConventions: 'UniversityConventions',
} as const;

export const MenuGroups = {
  Administrator: 'Administrator',
  Supervisor: 'Supervisor',
  UniversityReprezentative: 'UniversityReprezentative',
  LegalDepartment: 'LegalDepartment',
  Rector: 'Rector',
  Tutor: 'Tutor',
  OrganizationRepresentative: 'OrganizationRepresentative',
  General: 'General',
  Student: 'Student',
  UniversityCoordonator: 'UniversityCoordonator',
  UniversityProjectCoordinator: 'UniversityProjectCoordinator',
} as const;
